import { get, post, patch, del } from './client.js';

export const list = (params) => {
  const q = params ? '?' + new URLSearchParams(params).toString() : '';
  return get(`/platform/partners${q}`);
};

export const getOne = (partnerId) => get(`/platform/partners/${partnerId}`);
export const create = (body) => post('/platform/partners', body);
export const update = (partnerId, body) => patch(`/platform/partners/${partnerId}`, body);
export const remove = (partnerId) => del(`/platform/partners/${partnerId}`);
